export const selectIsUserLoggedIn = (state) => !!(state?.backendData?.account?.guid || state?.backendData?.currentUser?.guid)

export const selectCurrentUser = (state) => state.backendData.currentUser

export const selectAccount = (state) => state.backendData.account
